import { validSaved } from './notebook.ts';
import type { Notebook, SavedNotebook } from './notebook.ts';
export class RevisionConflict extends Error {}
export interface ProgressClient {
  get(): Promise<SavedNotebook | null>;
  save(document: Notebook, revision: number | null): Promise<SavedNotebook>;
}
export function progressClient(username: string): ProgressClient {
  const url = `/api/progress/${encodeURIComponent(username)}`;
  async function request(options?: RequestInit): Promise<SavedNotebook | null> {
    const response = await fetch(url, {
      ...options,
      cache: 'no-store',
      signal: AbortSignal.timeout(15000),
    });
    if (response.status === 409) throw new RevisionConflict();
    if (!response.ok) throw new Error('Could not reach saved progress. Please retry.');
    const value: unknown = await response.json();
    if (value !== null && !validSaved(value))
      throw new Error('Saved progress could not be read. It has not been replaced.');
    return value;
  }
  return {
    get: () => request(),
    async save(document, expectedRevision) {
      const value = await request({
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ document, expectedRevision }),
      });
      if (!value) throw new Error('Save was not confirmed.');
      return value;
    },
  };
}
